import { useQuery } from "@tanstack/react-query";
import { ErrorMessage, Spinner } from "app/components";
import { useResourcesContext } from "app/contexts/resources";
import { reinscripcionesService } from "app/services";
import { useEffect, useState } from "react";
import { useContext } from "react";
import { useParams } from "react-router-dom";

const { createContext } = require("react");

const EstablecimientoContext = createContext();

const initialState = {
  ciudad_id: 0,
  establecimiento_direccion_detallada: "",
  establecimiento_coordenadas: "",
  establecimiento_principal: false,
};

const initialDepto = {
  departamento_id: 0,
  ciudades: [],
};

export function EstablecimientoProvider({ children }) {
  const params = useParams();

  const { getDepartamento, getDepartamentoByCiudadId } = useResourcesContext();
  const [establecimiento, setEstablecimiento] = useState(initialState);
  const [departamento, setDepartamento] = useState(initialDepto);
  const [isEditing, setEditing] = useState(false);

  const establecimientoQuery = useQuery({
    queryKey: [
      "empresa:get:establecimiento",
      params.empresa_id,
      params.reinscripcion_id,
      params.establecimiento_id,
    ],
    queryFn: () =>
      reinscripcionesService.getEstablecimiento({
        empresaId: params.empresa_id,
        reinscripcionId: params.reinscripcion_id,
        establecimientoId: params.establecimiento_id,
      }),
    onSuccess: (data) => {
      setEstablecimiento(data);

      const departamento = getDepartamentoByCiudadId(data.ciudad_id);

      setDepartamento(departamento);

      setEditing(true);
    },
    enabled: !!params.establecimiento_id,
  });

  useEffect(() => {
    if (!!departamento.departamento_id) {
      const depto = getDepartamento(departamento.departamento_id);

      setDepartamento(depto);
    } else if (!!establecimiento.ciudad_id) {
      const depto = getDepartamentoByCiudadId(establecimiento.ciudad_id);

      setDepartamento(depto);
    }
  }, [
    departamento.departamento_id,
    getDepartamento,
    getDepartamentoByCiudadId,
    establecimiento.ciudad_id,
  ]);

  if (!!establecimientoQuery.isLoading && !!params.establecimiento_id) {
    return <Spinner label="Cargando el establecimiento..." />;
  } else if (!!establecimientoQuery.isFetching && !!params.establecimiento_id) {
    return <Spinner label="Recuperando el establecimiento..." />;
  } else if (
    !!establecimientoQuery.isRefetching &&
    !!params.establecimiento_id
  ) {
    return <Spinner label="Recargando el establecimiento..." />;
  } else if (!!establecimientoQuery.isError) {
    return (
      <ErrorMessage message={establecimientoQuery.error.response.statusText} />
    );
  }

  return (
    <EstablecimientoContext.Provider
      value={{
        establecimiento,
        setEstablecimiento,
        departamento,
        setDepartamento,
        isEditing,
      }}
    >
      {children}
    </EstablecimientoContext.Provider>
  );
}

export function useEstablecimientoContext() {
  const establecimientoContext = useContext(EstablecimientoContext);

  if (!establecimientoContext) {
    throw new Error(
      "useEstablecimientoContext should be used inside the EstablecimientoProvider."
    );
  }

  return establecimientoContext;
}
